import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChartWaterfall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-waterfall"} maskId="square-filled-radius-0-stroke-1-IconChartWaterfall"><path d="M22 20H2V19H22V20Z" fill="currentColor"/><path d="M4 15H3V11H4V15Z" fill="currentColor"/><path d="M21 15H20V4H21V15Z" fill="currentColor"/><path d="M8.25 13H7.25V6H8.25V13Z" fill="currentColor"/><path d="M12.5 13H11.5V9H12.5V13Z" fill="currentColor"/><path d="M16.75 10H15.75V5H16.75V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChartWaterfall;
